'use client';

import HeaderRedirectButtons from '@/shared/pid/components/DetailOrRecorTracking/HeaderRedirectButtons';
import { InfoActivitySkeleton } from '@/shared/pid/components/DetailOrRecorTracking/InfoActivity.skeleton';
import { TrackingDetailSkeleton } from '@/shared/pid/components/DetailOrRecorTracking/TrackingDetail.skeleton';

export default function Loading() {
  return (
    <div className=" tw-bg-neutral-light-200 tw-w-full tw-h-[100vh]">
      <div className="tw-w-full tw-inline-block tw-px-4.8">
        <div className="tw-w-full tw-pt-[2.6rem]">
          <HeaderRedirectButtons />
        </div>
        <div className="tw-flex tw-justify-between">
          <div className=" tw-w-[49%] ">
            <InfoActivitySkeleton />
          </div>
          <div className="tw-w-[49%] ">
            <TrackingDetailSkeleton />
          </div>
        </div>
      </div>
    </div>
  );
}
